module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-menu', {
    staticStyle: {
      "margin-top": "48px",
      "border-right": "none"
    },
    attrs: {
      "mode": "vertical",
      "unique-opened": "",
      "default-active": _vm.$route.path,
      "collapse": _vm.isCollapse
    }
  }, [_c('sidebar-item', {
    attrs: {
      "routes": _vm.current_routers
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe1039de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Sidebar.vue
// module id = 292
// module chunks = 48